import { Injectable } from '@angular/core';

import { ServiceInfo } from './models/display/serviceInfo'
import { Subject } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class DisplayUserActionService {
  serviceList : Array<ServiceInfo>;
  private countdownEndSource = new Subject<ServiceInfo>();
  public countdownEnd$ = this.countdownEndSource.asObservable();


  constructor() {
    //this.setOfflineServiceList();

   }
   public getOfflineServiceList() {
     return this.serviceList;
   }
   public destroy(){}
   
   getCurrentTheme()  :string {
    this.serviceList.forEach(service => {
      if (service.isSelected) { return  service.scssPrefix;}
    });
    return "";
   }

   getnNewSelected(id) {
     
      this.serviceList.forEach(service => {
        console.log(service)
        if (service.isSelected && service.id != id ) { service.isSelected = false;}
        if (service.id == id && !service.isSelected) { 
          service.isSelected = true;
             this.countdownEndSource.next(service);
        }
      });

      return this.serviceList;
   }

   public getSelected()  {
     this.serviceList.forEach(service => {
       if (service.isSelected) {return  service;}
     });
     this.serviceList[0];
   }

   private getSelectFirst() {
    let index = 0;
    this.serviceList.forEach(service => {
      index++;
      if (service.isSelected) {
        let tmp = service
        this.serviceList.slice(index, index + 1);
        this.serviceList.unshift(tmp);
        return ;
      }
    });
   }


  private setOfflineServiceList() {
    this.serviceList = [];
    this.serviceList.push(
      new ServiceInfo(0,"autopazeartage", "directions_car", true, "theme-autopartage", "/autopartage", "autopartage", "http://clem.mobi/img/global_homepage/menu/Autopartage.png", "Autopartage", "test kzsmfldsdklm zeporkzelkmfml ékzlefdc,slkd;v,ls:;dx zesdmfksdlfomsldfkmlsdfz")
    );
    this.serviceList.push(
      new ServiceInfo(1,"rechaazerge", "ev_station", false, "theme-recharge", "/recharge", "recharge", "http://clem.mobi/img/global_homepage/menu/Autopartage.png", "Recharge", "test kzsmfldsdklm zeporkzelkmfml ékzlefdc,slkd;v,ls:;dx zesdmfksdlfomsldfkmlsdfz")
    );
    this.serviceList.push(
      new ServiceInfo(2,"soazelidrive", "group", false, "theme-solidrive", "/solidrive", "covoiturage", "http://clem.mobi/img/global_homepage/menu/Autopartage.png", "Solidrive", "test kzsmfldsdklm zeporkzelkmfml ékzlefdc,slkd;v,ls:;dx zesdmfksdlfomsldfkmlsdfz")
    );
    this.countdownEndSource.next(this.serviceList[0]);
    return this.serviceList;
  }
}
